// Used in Feedback
export const Feedback = {
	toastInfoBackground: 'var(--epods--color-signal-info-bg)',
	toastPositiveBackground: 'var(--epods--color-signal-success-bg)',
	toastWarningBackground: 'var(--epods--color-signal-warning-bg)',
	toastNegativeBackground: 'var(--epods--color-signal-error-bg)',
	toastPhantomBackground: 'var(--epods--color-bg-transparent)',
};

export const CustomFeedback = {
	borderColorInfo: 'var(--epods--color-signal-info-border)',
	borderColorNegative: 'var(--epods--color-signal-error-border)',
	borderColorWarning: 'var(--epods--color-signal-warning-border)',
	borderColorPositive: 'var(--epods--color-signal-success-border)',
	borderColorPhantom: 'var(--epods--color-signal-phantom-border)',
	feedbackHeight: 'var(--epods--feedback-height)',
	feedbackBodyPaddingTopBottom: 'var(--epods--feedback-body-padding-topBottom)',
	feedbackBodyPaddingRightLeft: 'var(--epods--feedback-body-padding-rightLeft)',
	feedbackIconsMargin: 'var(--epods--feedback-icons-margin)',
};
